import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_OLD_DATA_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		ONENTER_GET_OLD_DATA_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		OLD_DATA_SYNC_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		oldData: [],
		oldDataFail: [],
		loginErr: false,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/old.js